/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Airegenerate1Inputs */

const en_airegenerate1 = /** @type {(inputs: Airegenerate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate`)
};

const de_airegenerate1 = /** @type {(inputs: Airegenerate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu generieren`)
};

/**
* | output |
* | --- |
* | "Regenerate" |
*
* @param {Airegenerate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const airegenerate1 = /** @type {((inputs?: Airegenerate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Airegenerate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_airegenerate1(inputs)
	return de_airegenerate1(inputs)
});
export { airegenerate1 as "aiRegenerate" }